



	import { Component, Vue, Prop } from 'vue-property-decorator';

	import { qiniuUploadUrl, qiniuDownloadTmp, globalType } from '@/utils/constant';
	import Editor from '../../utils/wangEditor.js';

	import { getCurrentDate } from '@/utils/common';
	import { getUploadToken } from '@/apis/common';
	import * as uuid from 'uuid';
	import Axios from 'axios';
	import { Progress } from '@/utils/common';
	import { Toast } from 'vant'
	const service = Axios.create({
		baseURL: '',
		responseType: 'json',
		timeout: 300000,
	});
	@Component({
		components: {},
	})
	export default class extends Vue {
		@Prop() public value!: string;
		@Prop() public keyFun!: (type: string) => string;
		private editorId = 'editor' + new Date().getTime();
		private wEditor: any;
		public initEditor() {
			this.wEditor = new Editor('#' + this.editorId);
			this.wEditor.customConfig.menus = [
				'head', // 标题
				'bold', // 粗体
				'fontSize', // 字号
				'fontName', // 字体
				'italic', // 斜体
				'underline', // 下划线
				'strikeThrough', // 删除线
				'foreColor', // 文字颜色
				'backColor', // 背景颜色
				'link', // 插入链接
				'list', // 列表
				'justify', // 对齐方式
				//          'quote',  // 引用
				//          'emoticon',  // 表情
				'table', // 表格
				// 'code',  // 插入代码
				'image',
				'undo', // 撤销
				'redo', // 重复
			];
			// 粘贴，自定义过滤
			// this.wEditor.customConfig.pasteTextHandle = filterXSS
			this.wEditor.customConfig.fontNames = [
				'微软雅黑',
				'宋体',
				'新宋体',
				'仿宋',
				'楷体',
				'黑体',
				'Arial',
				'Arial Black',
				'Times New Roman',
				'Courier New',
				'Tahoma',
				'Verdana',
			];
			this.wEditor.customConfig.zIndex = 100;
			this.wEditor.customConfig.uploadImgMaxLength = 1;
			let self = this;
			this.wEditor.customConfig.customUploadImg = async (files, insert) => {
				let file = files[0];
				let formdata = new FormData();
				let type = file.name.split('.').pop();
				if (globalType === 'public') {
					let res = await getUploadToken(0);
					if (res.success) {
						formdata.append('token', res.data);
					} else {
						return false;
					}
				}
				formdata.append('file', file);
				formdata.append('key', self.keyFun(type));
				var progressBar = new Progress(this.wEditor);
				let urlObj: any = await service({
					url: qiniuUploadUrl,
					method: 'post',
					data: formdata,
					onUploadProgress(e) {
						let percent = 0;
						// 进度条
						if (e.lengthComputable) {
							percent = e.loaded / e.total;
							progressBar.show(percent);
						}
					},
				});
				insert(qiniuDownloadTmp + urlObj.data.key);
			};
			this.wEditor.customConfig.onchange = (html) => {
				//          this.mailSignatureClone.content = this.wEditor.txt.html()
				this.$emit('input', html);
			};
			this.wEditor.customConfig.onblur = (html) => {
				this.$emit('onblur', html);
			};
			this.wEditor.customConfig.customAlert = (message) => {
				Toast.fail({
          duration: 2000,
          message
        })
			}
			this.wEditor.create();
			this.wEditor.isFocus = true;
			this.initData(this.value);
			this.$nextTick(() => {
				this.wEditor.$textElem[0].blur();
			});
		}
		public initData(value) {
			if (this.wEditor) {
				this.wEditor.txt.html(value || '');
			}
		}
		public mounted() {
			this.$nextTick(() => {
				this.initEditor();
			});
		}
	}
